import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import * as Yup from 'yup';

import { EventContext } from '../../../Contexts/EventContext';
import Datepicker from '../../../Shared/Components/Datepicker';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import Loading from '../../../Shared/Components/Loading';
import TextEditor from '../../../Shared/Components/TextEditor';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { number_format, showFirstRequestError } from '../../../Shared/utils/helper';
/** @format */
import Master from '../../Layouts/Master';

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
  match_style_id: Yup.number()
    .typeError('سبک مسابقه الزامی است')
    .required('سبک مسابقه الزامی است'),
  match_kinds: Yup.array()
    .typeError('نوع مسابقه الزامی است')
    .min(1, 'نوع مسابقه الزامی است')
    .max(1, 'فقط یک نوع مسابقه مجاز است'),
  province: Yup.number()
    .typeError('استان الزامی است')
    .required('استان الزامی است'),
  city: Yup.number().typeError('شهر الزامی است').required('شهر الزامی است'),
  register_start: Yup.string().required('شروع ثبت نام الزامی است'),
  register_end: Yup.string().required('پایان ثبت نام الزامی است'),
  start: Yup.string().required('شروع برگزاری الزامی است'),
  end: Yup.string().required('پایان برگزاری الزامی است'),
  allowed_person: Yup.number()
    .typeError('ظرفیت الزامی است')
    .required('ظرفیت الزامی است'),
  gender: Yup.number()
    .typeError('جنسیت الزامی است')
    .required('جنسیت الزامی است'),
  address: Yup.string()
    .nullable()
    .max(500, 'آدرس نمیتواند بیشتر از 500 کاراکتر باشد'),
  description: Yup.string().nullable(),
});

const CreateMatch = () => {
  const navigate = useNavigate();
  const eventContext = useContext(EventContext);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [, setLoadMatchKind] = useState(false);
  const [, setLoadCity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState([]);
  const [matchStyle, setMatchStyle] = useState([]);
  //One
  const [ages, setAges] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [ageId, setAgeId] = useState('');
  const [price, setPrice] = useState('');
  const [ageTitle, setAgeTitle] = useState('');
  const [provinceId, setProvinceId] = useState('');
  const [provinceTitle, setProvinceTitle] = useState('');
  const [errorAge, setErrorAge] = useState(false);
  //Team (submit payload; no team UI in create form yet)
  const [agesTeam] = useState([]);
  const [provincesTeam] = useState([]);
  const [postsTeam] = useState([]);
  const [errorAgeTeam, setErrorAgeTeam] = useState(false);
  const [agesLeague, setAgesLeague] = useState([]);
  const [provincesLeague, setProvincesLeague] = useState([]);
  const [postsLeague, setPostsLeague] = useState([]);
  const [ageIdLeague, setAgeIdLeague] = useState('');
  const [ageTitleLeague, setAgeTitleLeague] = useState('');
  const [agePriceLeague, setAgePriceLeague] = useState('');
  const [provinceIdLeague, setProvinceIdLeague] = useState('');
  const [provinceTitleLeague, setProvinceTitleLeague] = useState('');
  const [provinceCountLeague, setProvinceCountLeague] = useState('');
  const [provincePersonCountLeague, setProvincePersonCountLeague] = useState('');
  const [postIdLeague, setPostIdLeague] = useState('');
  const [postTitleLeague, setPostTitleLeague] = useState('');
  const [postCountLeague, setPostCountLeague] = useState('');
  const [errorPostLeague, setErrorPostLeague] = useState(false);
  //Double
  const [agesDouble, setAgesDouble] = useState([]);
  const [provincesDouble, setProvincesDouble] = useState([]);
  const [ageIdDouble, setAgeIdDouble] = useState('');
  const [priceDouble, setPriceDouble] = useState('');
  const [ageTitleDouble, setAgeTitleDouble] = useState('');
  const [provinceIdDouble, setProvinceIdDouble] = useState('');
  const [provinceTitleDouble, setProvinceTitleDouble] = useState('');
  const [errorAgeDouble, setErrorAgeDouble] = useState(false);
  const [provinceCountDouble, setProvinceCountDouble] = useState('');
  const [provinceCountPersonDouble, setProvinceCountPersonDouble] = useState(2);
  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInfo = async () => {
    setLoading(true);
    await useApi.get(
      '/general/province',
      {},
      (res) => {
        eventContext.provinces = res.data.data;
      },
      (err) => {
        console.log(err);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
    await useApi.get(
      '/panel/base/age',
      {},
      (res) => {
        eventContext.ages = res.data.data;
      },
      (err) => {
        console.log(err);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
    await useApi.get(
      '/panel/base/post?all=true',
      {},
      (res) => {
        eventContext.posts = res.data.data;
      },
      (err) => {
        console.log(err);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
    await useApi.get(
      '/panel/base/match-style?all=1',
      {},
      (res) => {
        eventContext.matchStyles = res.data.data;
        setLoading(false);
      },
      (err) => {
        console.log(err);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const getCities = async (provinceId) => {
    setLoadCity(true);
    await useApi.get(
      `/general/city/${provinceId}`,
      {},
      (res) => {
        eventContext.cities = res.data.data;
        setLoadCity(false);
      },
      (err) => {
        console.log(err);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoadCity(false);
      },
    );
  };

  const getMatchKindByMatchStyle = async (matchStyleId) => {
    setLoadMatchKind(true);
    await useApi.get(
      `/panel/base/match-style/${matchStyleId}`,
      {},
      (res) => {
        eventContext.matchKinds = res.data.data?.match_kind;
        setLoadMatchKind(false);
      },
      (err) => {
        console.log(err);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoadMatchKind(false);
      },
    );
  };

  const addAge = () => {
    if (
      price.length === 0 ||
      price === undefined ||
      ageId.length === 0 ||
      ageTitle.length === 0
    ) {
      setErrorAge(true);
      return;
    }

    setErrorAge(false);
    let agesCpy = [...ages];
    const ageIndex = agesCpy.findIndex((a) => a.age_id === ageId);

    if (ageIndex === -1) {
      agesCpy.push({ age_id: ageId, person_price: price, title: ageTitle });
    } else {
      agesCpy[ageIndex]['person_price'] = price;
      agesCpy[ageIndex]['title'] = ageTitle;
    }
    setPrice('');
    setAgeId('');
    setAgeTitle('');
    setAges(agesCpy);
  };
  const addProvince = () => {
    setErrorAge(false);
    let provinceCpy = [...provinces];

    if (provinceId === 'all') {
      eventContext.provinces.forEach((item) => {
        const provinceIndex = provinceCpy.findIndex(
          (a) => a.province_id === item.id,
        );

        if (provinceIndex === -1) {
          provinceCpy.push({ province_id: item.id, title: item.name });
        } else {
          provinceCpy[provinceIndex]['title'] = item.name;
        }
        removeProvinceOptions('select-age-one', item.id, item.name);
      });
    } else {
      const provinceIndex = provinceCpy.findIndex(
        (a) => a.province_id === provinceId,
      );
      if (provinceIndex === -1) {
        provinceCpy.push({ province_id: provinceId, title: provinceTitle });
      } else {
        provinceCpy[provinceIndex]['title'] = provinceTitle;
      }
      removeProvinceOptions('select-age-one', provinceId, provinceTitle);
    }

    // setProvinceId('');
    // setProvinceTitle('');
    setProvinces(provinceCpy);
  };

  const removeProvinceOptions = (tagId, id, name) => {
    let selectProvince = document.getElementById(tagId);
    for (let i = 0; i < selectProvince.length; i++) {
      if (selectProvince.options[i].value === `${id}-${name}`) {
        selectProvince.remove(i);
        selectProvince.options[1].selected = true;
        let val = selectProvince.value.split('-');
        setProvinceId(val[0]);
        setProvinceTitle(val[1]);
      }
    }
  };

  const addAgeDouble = () => {
    if (
      priceDouble.length === 0 ||
      priceDouble === undefined ||
      ageIdDouble.length === 0 ||
      ageTitleDouble.length === 0
    ) {
      setErrorAgeDouble(true);
      return;
    }

    setErrorAge(false);
    let agesCpy = [...agesDouble];
    const ageIndex = agesCpy.findIndex((a) => a.age_id === ageIdDouble);

    if (ageIndex === -1) {
      agesCpy.push({
        age_id: ageIdDouble,
        person_price: priceDouble,
        title: ageTitleDouble,
      });
    } else {
      agesCpy[ageIndex]['person_price'] = priceDouble;
      agesCpy[ageIndex]['title'] = ageTitleDouble;
    }
    setPriceDouble('');
    setAgeIdDouble('');
    setAgeTitleDouble('');
    setAgesDouble(agesCpy);
  };
  const addProvinceDouble = () => {
    setErrorAgeDouble(false);
    let provinceCpy = [...provincesDouble];

    // if (provinceIdDouble === 0) {
    // 	eventContext.provinces.map((item) => {
    // 		const provinceIndex = provinceCpy.findIndex(
    // 			(a) => a.province_id === item.id,
    // 		);

    // 		if (provinceIndex === -1) {
    // 			provinceCpy.push({ province_id: item.id, title: item.name });
    // 		} else {
    // 			provinceCpy[provinceIndex]['title'] = item.name;
    // 		}
    // 	});

    // 	setProvincesDouble(provinceCpy);
    // 	return;
    // }

    const provinceIndex = provinceCpy.findIndex(
      (a) => a.province_id === provinceIdDouble,
    );

    if (provinceIndex === -1) {
      provinceCpy.push({
        province_id: provinceIdDouble,
        title: provinceTitleDouble,
        province_count_person_double: provinceCountPersonDouble,
        province_count_double: provinceCountDouble,
      });
    } else {
      provinceCpy[provinceIndex]['title'] = provinceTitleDouble;
      provinceCpy[provinceIndex]['province_count_person_double'] =
        provinceCountPersonDouble;
      provinceCpy[provinceIndex]['province_count_double'] = provinceCountDouble;
    }
    let selectProvince = document.getElementById('select-age-double');
    for (let i = 0; i < selectProvince.length; i++) {
      if (
        selectProvince.options[i].value ===
        `${provinceIdDouble}-${provinceTitleDouble}`
      ) {
        selectProvince.remove(i);
        selectProvince.options[1].selected = true;
        let val = selectProvince.value.split('-');
        setProvinceIdDouble(val[0]);
        setProvinceTitleDouble(val[1]);
        // setProvinceCountPersonTeam(provinceCountPersonTeam);
        // setProvinceCountTeam(provinceCountTeam);
      }
    }
    // setProvinceIdDouble('');
    // setProvinceTitleDouble('');
    setProvincesDouble(provinceCpy);
  };

  const removeAge = (ageID) => {
    let ageCpy = [...ages];
    let agesFilter = ageCpy.filter((a) => a.age_id !== ageID);

    setAges(agesFilter);
  };
  const removeProvinceId = (provinceID) => {
    let provinceCpy = [...provinces];
    let provinceFind = provinceCpy.find((a) => a.province_id === provinceID);
    let provinceFilter = provinceCpy.filter((a) => a.province_id !== provinceID);

    let selectProvince = document.getElementById('select-age-one');
    var opt = document.createElement('option');
    opt.value = `${provinceID}-${provinceFind.title}`;
    opt.innerHTML = provinceFind.title;
    opt.selected = true;
    selectProvince.appendChild(opt);
    setProvinceId(provinceID);
    setProvinceTitle(provinceFind.title);

    setProvinces(provinceFilter);
  };

  const addAgeLeague = () => {
    if (
      agePriceLeague.length === 0 ||
      agePriceLeague === undefined ||
      ageIdLeague.length === 0 ||
      ageTitleLeague.length === 0
    ) {
      setErrorAgeTeam(true);
      return;
    }

    setErrorAge(false);
    let agesCpy = [...agesLeague];
    const ageIndex = agesCpy.findIndex((a) => a.age_id === ageIdLeague);

    if (ageIndex === -1) {
      agesCpy.push({
        age_id: ageIdLeague,
        person_price: agePriceLeague,
        title: ageTitleLeague,
      });
    } else {
      agesCpy[ageIndex]['person_price'] = agePriceLeague;
      agesCpy[ageIndex]['title'] = ageTitleLeague;
    }
    setAgePriceLeague('');
    setAgeIdLeague('');
    setAgeTitleLeague('');
    setAgesLeague(agesCpy);
  };
  const addPostLeague = () => {
    if (
      postIdLeague.length === 0 ||
      postIdLeague === undefined ||
      postCountLeague.length === 0
    ) {
      setErrorPostLeague(true);
      return;
    }

    setErrorPostLeague(false);
    let postsCopy = [...postsLeague];
    const postIndex = postsCopy.findIndex((a) => a.post_id === postIdLeague);

    if (postIndex === -1) {
      postsCopy.push({
        post_id: postIdLeague,
        title: postTitleLeague,
        count: postCountLeague,
      });
    } else {
      postsCopy[postIndex]['post_id'] = postIdLeague;
      postsCopy[postIndex]['title'] = postTitleLeague;
      postsCopy[postIndex]['count'] = postCountLeague;
    }
    setPostIdLeague('');
    setPostTitleLeague('');
    setPostCountLeague('');
    setPostsLeague(postsCopy);
  };
  const addProvinceLeague = () => {
    setErrorAgeTeam(false);
    let provinceCpy = [...provincesLeague];
    let provinceCountArray = provinceCpy.map((p) =>
      parseInt(p.province_count_league),
    );
    provinceCountArray.push(parseInt(provinceCountLeague));

    if (_.sum(provinceCountArray) > matchStyle?.allowed_team) {
      return error('تعداد تیم انتخابی بیشتر از تعداد تیم مجاز است.');
    }
    if (parseInt(provincePersonCountLeague) > matchStyle?.allowed_team_person) {
      return error('تعداد نفرات تیم انتخابی بیشتر از تعداد تیم مجاز است.');
    }
    let selectProvince = document.getElementById('select-age-league');
    const provinceIndex = provinceCpy.findIndex(
      (a) => a.province_id === provinceIdLeague,
    );

    if (provinceIndex === -1) {
      provinceCpy.push({
        province_id: provinceIdLeague,
        title: provinceTitleLeague,
        province_count_league: provinceCountLeague,
        province_count_person_league: provincePersonCountLeague,
      });
    } else {
      provinceCpy[provinceIndex]['title'] = provinceTitleLeague;
      provinceCpy[provinceIndex]['province_count_league'] = provinceCountLeague;
      provinceCpy[provinceIndex]['province_count_person_league'] =
        provincePersonCountLeague;
    }

    if (selectProvince) {
      for (let i = 0; i < selectProvince.length; i++) {
        if (
          selectProvince.options[i].value ===
          `${provinceIdLeague}-${provinceTitleLeague}`
        ) {
          selectProvince.remove(i);
          break;
        }
      }
    }

    setProvincesLeague(provinceCpy);
  };


  const removeAgeLeague = (ageID) => {
    setAgesLeague(agesLeague.filter((a) => a.age_id !== ageID));
  };
  const removePostLeague = (postId) => {
    setPostsLeague(postsLeague.filter((p) => p?.post_id !== postId));
  };
  const removeProvinceIdLeague = (provinceID) => {
    setProvincesLeague(provincesLeague.filter((a) => a.province_id !== provinceID));
  };
  const editProvinceLeague = (provinceIndex, name, value) => {
    const provinceCpy = [...provincesLeague];
    provinceCpy[provinceIndex][name] = value;
    setProvincesLeague(provinceCpy);
  };

  const removeAgeDouble = (ageID) => {
    let ageCpy = [...agesDouble];
    let agesFilter = ageCpy.filter((a) => a.age_id !== ageID);

    setAgesDouble(agesFilter);
  };
  const removeProvinceIdDouble = (provinceID) => {
    let provinceCpy = [...provincesDouble];
    let provinceFind = provinceCpy.find((a) => a.province_id === provinceID);
    let provinceFilter = provinceCpy.filter((a) => a.province_id !== provinceID);

    let selectProvince = document.getElementById('select-age-double');
    var opt = document.createElement('option');
    opt.value = `${provinceID}-${provinceFind.title}`;
    opt.innerHTML = provinceFind.title;
    opt.selected = true;
    selectProvince.appendChild(opt);
    setProvinceIdDouble(provinceID);
    setProvinceTitleDouble(provinceFind.title);
    setProvinceCountPersonDouble(provinceFind.province_count_person_double);
    setProvinceCountDouble(provinceFind.province_count_double);

    setProvincesDouble(provinceFilter);
  };

  const onSubmitForm = async (values, setSubmitting) => {
    let match_ages = [];
    let match_allowed_provinces = [];
    let match_posts = [];

    if (type.find((t) => t.name === 'انفرادی') !== undefined) {
      if (ages.length === 0 || provinces.length === 0) {
        return error(
          'رده سنی و استان های مسابقات انفرادی نمی تواند خالی باشد.',
        );
      }
      match_ages.push({
        type: 'single',
        matchKind: type.find((t) => t.name === 'انفرادی').id,
        items: ages,
      });
      match_allowed_provinces.push({
        type: 'single',
        matchKind: type.find((t) => t.name === 'انفرادی').id,
        provinces: provinces,
      });
    }
    if (type.find((t) => t.name === 'تیمی') !== undefined) {
      if (agesTeam.length === 0 || provincesTeam.length === 0) {
        return error('رده سنی و استان های مسابقات تیمی نمی تواند خالی باشد.');
      }
      match_ages.push({
        type: 'team',
        matchKind: type.find((t) => t.name === 'تیمی').id,
        items: agesTeam,
      });
      match_allowed_provinces.push({
        type: 'team',
        matchKind: type.find((t) => t.name === 'تیمی').id,
        provinces: provincesTeam,
      });

      match_posts.push({
        type: 'team',
        matchKind: type.find((t) => t.name === 'تیمی').id,
        posts: postsTeam,
      });
    }

    if (type.find((t) => t.name === 'لیگ') !== undefined) {
      if (agesLeague.length === 0 || provincesLeague.length === 0) {
        return error('رده سنی و استان های مسابقات لیگ نمی تواند خالی باشد.');
      }
      match_ages.push({
        type: 'league',
        matchKind: type.find((t) => t.name === 'لیگ').id,
        items: agesLeague,
      });
      match_allowed_provinces.push({
        type: 'league',
        matchKind: type.find((t) => t.name === 'لیگ').id,
        provinces: provincesLeague,
      });
      match_posts.push({
        type: 'league',
        matchKind: type.find((t) => t.name === 'لیگ').id,
        posts: postsLeague,
      });
    }

    if (type.find((t) => t.name === 'دوبل') !== undefined) {
      if (agesDouble.length === 0 || provincesDouble.length === 0) {
        return error('رده سنی و استان های مسابقات دوبل نمی تواند خالی باشد.');
      }
      match_ages.push({
        type: 'double',
        matchKind: type.find((t) => t.name === 'دوبل').id,
        items: agesDouble,
      });
      match_allowed_provinces.push({
        type: 'double',
        matchKind: type.find((t) => t.name === 'دوبل').id,
        provinces: provincesDouble,
      });
    }
    values['match_ages'] = match_ages;
    values['match_allowed_provinces'] = match_allowed_provinces;
    values['match_posts'] = match_posts;

    if (values.match_ages.length === 0) {
      return error('یکی از لیست های انفرادی، تیمی، لیگ و یا دوبل باید تکمیل شود');
    }
    if (values.registration_mode === 'reserve_list') {
      const codes = String(values.reserve_national_codes || '').trim();
      if (!codes) {
        return error('در حالت لیست رزرو حداقل یک کد ملی وارد کنید.');
      }
    }
    setSubmitFormLoading(true);

    await useApi.post(
      '/panel/match',
      values,
      (res) => {
        success('مسابقه با موفقیت ایجاد شد');
        navigate('/panel/matches/lists', { replace: true });
      },
      (err) => {
        setSubmitFormLoading(false);
        if (err?.status === 422 && err?.data?.errors) {
          showFirstRequestError(err.data.errors);
          return;
        }
        error(err?.data?.message || 'خطایی در ثبت اطلاعات پیش آمده است.');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <Formik
        initialValues={{
          title: '',
          match_style_id: '',
          match_kinds: [],
          province: '',
          city: '',
          register_start: '',
          register_end: '',
          start: '',
          end: '',
          allowed_person: 0,
          gender: '',
          address: '',
          description: '',
          registration_mode: 'open',
          reserve_national_codes: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='row border rounded mt-3'>
              <div className='col-12'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>عنوان مسابقه</label>
                    <input
                      name='title'
                      value={values.title}
                      onChange={handleChange}
                      type='text'
                      className='form-control'
                    />
                    <ErrorMessage error={errors.title} />
                  </div>
                </div>
              </div>
              {eventContext?.matchStyles?.length > 0 && (
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <div className='d-flex flex-column mt-1 mx-2'>
                      <label>سبک برگزاری</label>
                      <Select
                        options={eventContext.matchStyles}
                        onChange={(value) => {
                          setMatchStyle(value);
                          getMatchKindByMatchStyle(value.id);
                          setFieldValue('match_style_id', value.id, true);
                        }}
                        noOptionsMessage={() =>
                          'سبک برگزاری جهت انتخاب یافت نشد.'
                        }
                        getOptionLabel={(c) => c.title}
                        getOptionValue={(c) => c.id}
                        className='w-100'
                        placeholder='انتخاب کنید...'
                      />

                      <ErrorMessage error={errors.match_style_id} />
                    </div>
                  </div>
                </div>
              )}
              {eventContext?.matchKinds?.length > 0 && (
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <div className='d-flex flex-column mt-1 mx-2'>
                      <label>نوع مسابقه</label>
                      <Select
                        options={eventContext.matchKinds}
                        value={
                          values.match_kinds?.[0]
                            ? eventContext.matchKinds?.find(
                                (k) => k.id === values.match_kinds[0],
                              ) ?? null
                            : null
                        }
                        onChange={(value) => {
                          setType(value ? [value] : []);
                          setFieldValue(
                            'match_kinds',
                            value ? [value.id] : [],
                            true,
                          );
                        }}
                        noOptionsMessage={() =>
                          'نوع مسابقه جهت انتخاب یافت نشد.'
                        }
                        getOptionLabel={(c) => c.name}
                        getOptionValue={(c) => c.id}
                        className='w-100'
                        placeholder='انتخاب کنید...'
                      />

                      <ErrorMessage error={errors.match_kinds} />
                    </div>
                  </div>
                </div>
              )}
              {eventContext?.provinces?.length > 0 && (
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <div className='d-flex flex-column mt-1 mx-2'>
                      <label>استان محل برگزاری</label>
                      <Select
                        options={eventContext.provinces}
                        onChange={(value) => {
                          getCities(value.id);
                          setFieldValue('province', value.id, true);
                        }}
                        noOptionsMessage={() =>
                          'نوع مسابقه جهت انتخاب یافت نشد.'
                        }
                        getOptionLabel={(c) => c.name}
                        getOptionValue={(c) => c.id}
                        className='w-100'
                        placeholder='انتخاب کنید...'
                      />

                      <ErrorMessage error={errors.province} />
                    </div>
                  </div>
                </div>
              )}
              {eventContext?.cities?.length > 0 && (
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <div className='d-flex flex-column mt-1 mx-2'>
                      <label>شهر محل برگزاری</label>
                      <Select
                        options={eventContext.cities}
                        onChange={(value) => {
                          setFieldValue('city', value.id, true);
                        }}
                        noOptionsMessage={() =>
                          'نوع مسابقه جهت انتخاب یافت نشد.'
                        }
                        getOptionLabel={(c) => c.name}
                        getOptionValue={(c) => c.id}
                        className='w-100'
                        placeholder='انتخاب کنید...'
                      />

                      <ErrorMessage error={errors.city} />
                    </div>
                  </div>
                </div>
              )}

              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>شروع ثبت نام</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name='register_start'
                      format='YYYY/MM/DD HH:mm:ss'
                      showSelectTime={true}
                      value={values.register_start}
                    />
                    <ErrorMessage error={errors.register_start} />
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>پایان ثبت نام</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name='register_end'
                      format='YYYY/MM/DD HH:mm:ss'
                      showSelectTime={true}
                      value={values.register_end}
                    />
                    <ErrorMessage error={errors.register_end} />
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>نوع ثبت‌نام</label>
                    <select
                      name='registration_mode'
                      className='form-control'
                      value={values.registration_mode}
                      onChange={handleChange}
                    >
                      <option value='open'>عادی (همه واجد شرایط)</option>
                      <option value='reserve_list'>لیست رزرو</option>
                    </select>
                  </div>
                </div>
              </div>

              {values.registration_mode === 'reserve_list' && (
                <div className='col-12'>
                  <div className='form-group'>
                    <div className='d-flex flex-column mt-1 mx-2'>
                      <label>کدهای ملی لیست رزرو (هر کد در یک خط)</label>
                      <textarea
                        name='reserve_national_codes'
                        className='form-control'
                        rows={6}
                        value={values.reserve_national_codes}
                        onChange={handleChange}
                        placeholder='9001000037&#10;9001000045'
                      />
                      <small className='text-muted mt-1'>
                        فقط کاربران موجود در سیستم با حق عضویت معتبر می‌توانند ثبت‌نام کنند.
                      </small>
                    </div>
                  </div>
                </div>
              )}

              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>شروع برگزاری</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name='start'
                      value={values.start}
                    />
                    <ErrorMessage error={errors.start} />
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>پایان برگزاری</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name='end'
                      value={values.end}
                    />
                    <ErrorMessage error={errors.end} />
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>ظرفیت</label>
                    <input
                      name='allowed_person'
                      value={values.allowed_person}
                      onChange={handleChange}
                      type='number'
                      className='form-control'
                    />
                    <ErrorMessage error={errors.allowed_person} />
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>جنسیت</label>
                    <select
                      className='form-control'
                      name='gender'
                      onChange={handleChange}
                      value={values.gender}
                    >
                      <option>انتخاب کنید</option>
                      <option value='1'>مرد</option>
                      <option value='2'>زن</option>
                      <option value='3'>مشترک</option>
                    </select>
                    <ErrorMessage error={errors.gender} />
                  </div>
                </div>
              </div>
              {type.find((t) => t.name === 'انفرادی') !== undefined && (
                <>
                  <div className='col-12'>
                    <h1 className='flex flex-column border-bottom pb-2 my-2 f-14'>
                      انفرادی
                    </h1>
                  </div>

                  <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    {eventContext.ages?.length > 0 && (
                      <div className='col-12'>
                        <div className='form-group'>
                          <label>انتخاب رده سنی</label>
                          <div className='d-flex flex-row justify-content-between'>
                            <select
                              id='select-age'
                              className={`form-control ${
                                errorAge && 'border-danger'
                              }`}
                              onChange={(e) => {
                                let value = e.target.value.split('-');
                                setAgeId(value?.[0]);
                                setAgeTitle(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                رده سنی
                              </option>
                              {eventContext.ages?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + '-' + item.title}
                                >
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <input
                              onChange={(e) => setPrice(e.target.value)}
                              type='text'
                              value={price}
                              placeholder='هزینه انفرادی (ریال)'
                              className={`form-control mx-1 ${
                                errorAge && 'border-danger'
                              }`}
                            />

                            <i
                              onClick={() => addAge()}
                              className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                            ></i>
                          </div>
                          {ages?.map((item) => (
                            <div
                              className='d-flex flex-row justify-content-between my-2'
                              key={item.id}
                            >
                              <input
                                disabled
                                type='text'
                                className='form-control mx-1'
                                value={item.title}
                              />
                              <input
                                disabled
                                type='text'
                                className='form-control mx-1'
                                value={number_format(item.person_price)}
                              />

                              <i
                                onClick={() => removeAge(item.age_id)}
                                className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {eventContext.provinces?.length > 0 && (
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='form-group'>
                        <label>
                          انتخاب استان های مجاز (ظرفیت کل‌ :{' '}
                          {values?.allowed_person ?? 0} نفر)
                        </label>
                        <div className='d-flex flex-row justify-content-between'>
                          <select
                            id='select-age-one'
                            className='form-control'
                            onChange={(e) => {
                              let value = e.target.value.split('-');
                              setProvinceId(value?.[0]);
                              setProvinceTitle(value?.[1]);
                            }}
                          >
                            <option selected={true} disabled={true}>
                              انتخاب استان
                            </option>
                            <option value='all-all'>همه</option>

                            {eventContext.provinces?.map((item) => (
                              <option
                                key={item.id}
                                value={item.id + '-' + item.name}
                              >
                                {item.name}
                              </option>
                            ))}
                          </select>

                          <i
                            onClick={() => addProvince()}
                            className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                          ></i>
                        </div>
                        {provinces.length > 0 && (
                          <div
                            className='overflow-auto border border-info p-2 my-2 rounded'
                            style={{ maxHeight: '200px' }}
                          >
                            {provinces?.map((item) => (
                              <div
                                className='d-flex flex-row my-2'
                                key={item.id}
                              >
                                <div className='d-flex flex-row'>
                                  <input
                                    disabled
                                    type='text'
                                    className='form-control mx-1'
                                    value={item.title}
                                  />
                                </div>
                                <i
                                  onClick={() =>
                                    removeProvinceId(item.province_id)
                                  }
                                  className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                                ></i>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {type.find((t) => t.name === 'لیگ') !== undefined && (
                <>
                  <div className='col-12'>
                    <h1 className='flex flex-column border-bottom pb-2 my-2 f-14'>
                      لیگ
                    </h1>
                  </div>
                  {eventContext.ages?.length > 0 && (
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='col-12'>
                        <div className='form-group'>
                          <label>انتخاب رده سنی</label>
                          <div className='d-flex flex-row justify-content-beetween'>
                            <select
                              id='select-age-league'
                              className={`form-control ${
                                errorAgeTeam && 'border-danger'
                              }`}
                              onChange={(e) => {
                                let value = e.target.value.split('-');
                                setAgeIdLeague(value?.[0]);
                                setAgeTitleLeague(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                رده سنی
                              </option>
                              {eventContext.ages?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + '-' + item.title}
                                >
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <input
                              onChange={(e) => setAgePriceLeague(e.target.value)}
                              type='text'
                              value={agePriceLeague}
                              placeholder='هزینه لیگ (ریال)'
                              className={`form-control mx-1 ${
                                errorAgeTeam && 'border-danger'
                              }`}
                            />

                            <i
                              onClick={() => addAgeLeague()}
                              className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                            ></i>
                          </div>
                          {agesLeague?.map((item) => (
                            <div
                              className='d-flex flex-row justify-content-between my-2'
                              key={item.id}
                            >
                              <input
                                disabled
                                type='text'
                                className='form-control mx-1'
                                value={item.title}
                              />
                              <input
                                disabled
                                type='text'
                                className='form-control mx-1'
                                value={number_format(item.person_price)}
                              />

                              <i
                                onClick={() => removeAgeLeague(item.age_id)}
                                className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                      {eventContext.posts?.length > 0 && (
                        <div className='col-12'>
                          <div className='form-group'>
                            <label>انتخاب سمت</label>
                            <div className='d-flex flex-row justify-content-between'>
                              <select
                                id='select-post-league'
                                className={`form-control w-50 ${
                                  errorPostLeague && 'border-danger'
                                }`}
                                onChange={(e) => {
                                  let value = e.target.value.split('-');
                                  setPostIdLeague(value?.[0]);
                                  setPostTitleLeague(value?.[1]);
                                }}
                              >
                                <option selected={true} disabled={true}>
                                  سمت
                                </option>
                                {eventContext.posts?.map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id + '-' + item.title}
                                  >
                                    {item.title}
                                  </option>
                                ))}
                              </select>
                              <input
                                onChange={(e) =>
                                  setPostCountLeague(e.target.value)
                                }
                                type='number'
                                value={postCountLeague}
                                placeholder='تعداد'
                                className={`form-control mx-1  w-50 ${
                                  errorPostLeague && 'border-danger'
                                }`}
                              />

                              <i
                                onClick={() => addPostLeague()}
                                className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                              ></i>
                            </div>
                            {postsLeague?.map((item) => (
                              <div
                                className='d-flex flex-row justify-content-between my-2'
                                key={item.id}
                              >
                                <input
                                  disabled
                                  type='text'
                                  className='form-control mx-1'
                                  value={item.title}
                                />
                                <input
                                  disabled
                                  type='text'
                                  className='form-control mx-1'
                                  value={item.count}
                                />

                                <i
                                  onClick={() => removePostLeague(item.post_id)}
                                  className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {eventContext.provinces?.length > 0 && (
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='form-group'>
                        <label>انتخاب استان های مجاز </label>
                        <div className='d-flex flex-row'>
                          <div className='d-flex flex-row justify-content-between'>
                            <select
                              id='select-age-team'
                              className='form-control w-100'
                              onChange={(e) => {
                                let value = e.target.value.split('-');
                                setProvinceIdLeague(value?.[0]);
                                setProvinceTitleLeague(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                انتخاب استان
                              </option>
                              <option value='all-all'>همه</option>
                              {eventContext.provinces?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + '-' + item.name}
                                >
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <input
                            type='text'
                            className='form-control w-30'
                            onChange={(e) =>
                              setProvinceCountLeague(e.target.value)
                            }
                            value={provinceCountLeague}
                            placeholder='تعداد تیم'
                          />
                          <input
                            type='text'
                            className='form-control w-30'
                            onChange={(e) =>
                              setProvincePersonCountLeague(e.target.value)
                            }
                            value={provincePersonCountLeague}
                            placeholder='تعداد افراد تیم'
                          />
                          <i
                            onClick={() => addProvinceLeague()}
                            className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                          ></i>
                        </div>
                        {provincesLeague.length > 0 && (
                          <div
                            className='overflow-auto border border-info p-2 my-2 rounded'
                            style={{ maxHeight: '200px' }}
                          >
                            <div className='d-flex flex-row my-2 justify-content-around'>
                              <label>استان</label>
                              <label>تعداد تیم</label>
                              <label>تعداد افراد تیم</label>
                            </div>
                            {provincesLeague?.map((item, index) => (
                              <div
                                className='d-flex flex-row my-2'
                                key={item.id}
                              >
                                <div className='d-flex flex-row'>
                                  <input
                                    disabled
                                    type='text'
                                    className='form-control mx-1'
                                    value={item.title}
                                  />
                                  <input
                                    type='text'
                                    onChange={(e) =>
                                      editProvinceLeague(
                                        index,
                                        'province_count_league',
                                        e.target.value,
                                      )
                                    }
                                    className='form-control mx-1'
                                    value={item.province_count_league}
                                  />
                                  <input
                                    type='text'
                                    onChange={(e) =>
                                      editProvinceLeague(
                                        index,
                                        'province_count_person_league',
                                        e.target.value,
                                      )
                                    }
                                    className='form-control mx-1'
                                    value={item.province_count_person_league}
                                  />
                                </div>
                                <i
                                  onClick={() =>
                                    removeProvinceIdLeague(item.province_id)
                                  }
                                  className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                                ></i>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {type.find((t) => t.name === 'دوبل')
               !== undefined && (
                <>
                  <div className='col-12'>
                    <h1 className='flex flex-column border-bottom pb-2 my-2 f-14'>
                      دوبل
                    </h1>
                  </div>
                  {eventContext.ages?.length > 0 && (
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='col-12'>
                        <div className='form-group'>
                          <label>انتخاب رده سنی</label>
                          <div className='d-flex flex-row justify-content-between'>
                            <select
                              id='select-age'
                              className={`form-control ${
                                errorAgeDouble && 'border-danger'
                              }`}
                              onChange={(e) => {
                                let value = e.target.value.split('-');
                                setAgeIdDouble(value?.[0]);
                                setAgeTitleDouble(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                رده سنی
                              </option>
                              {eventContext.ages?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + '-' + item.title}
                                >
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <input
                              onChange={(e) => setPriceDouble(e.target.value)}
                              type='text'
                              value={priceDouble}
                              placeholder='هزینه دوبل (ریال)'
                              className={`form-control mx-1 ${
                                errorAgeDouble && 'border-danger'
                              }`}
                            />

                            <i
                              onClick={() => addAgeDouble()}
                              className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                            ></i>
                          </div>
                          {agesDouble?.map((item) => (
                            <div
                              className='d-flex flex-row justify-content-around my-2'
                              key={item.id}
                            >
                              <div className='d-flex flex-row'>
                                <input
                                  disabled
                                  type='text'
                                  className='form-control mx-1'
                                  value={item.title}
                                />
                                <input
                                  disabled
                                  type='text'
                                  className='form-control mx-1'
                                  value={number_format(item.person_price)}
                                />
                              </div>
                              <i
                                onClick={() => removeAgeDouble(item.age_id)}
                                className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {eventContext.provinces?.length > 0 && (
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='form-group'>
                        <label>انتخاب استان های مجاز </label>
                        <div className='d-flex flex-row'>
                          <div className='d-flex flex-row'>
                            <select
                              id='select-age-double'
                              className='form-control'
                              onChange={(e) => {
                                let value = e.target.value.split('-');
                                setProvinceIdDouble(value?.[0]);
                                setProvinceTitleDouble(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                انتخاب استان
                              </option>

                              {eventContext.provinces?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + '-' + item.name}
                                >
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <input
                            type='text'
                            className='form-control w-30'
                            onChange={(e) =>
                              setProvinceCountDouble(e.target.value)
                            }
                            value={provinceCountDouble}
                            placeholder='تعداد تیم'
                          />
                          <input
                            type='text'
                            className='form-control w-30'
                            disabled
                            value='2'
                            placeholder='تعداد افراد تیم'
                          />
                          <i
                            onClick={() => addProvinceDouble()}
                            className='fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer'
                          ></i>
                        </div>
                        {provincesDouble.length > 0 && (
                          <div
                            className='overflow-auto border border-info p-2 my-2 rounded'
                            style={{ maxHeight: '200px' }}
                          >
                            <div className='d-flex flex-row my-2 justify-content-around'>
                              <label>استان</label>
                              <label>تعداد تیم</label>
                              <label>تعداد افراد تیم</label>
                            </div>
                            {provincesDouble?.map((item) => (
                              <div
                                className='d-flex flex-row my-2'
                                key={item.id}
                              >
                                <div className='d-flex flex-row'>
                                  <input
                                    disabled
                                    type='text'
                                    className='form-control mx-1'
                                    value={item.title}
                                  />

                                  <input
                                    disabled
                                    type='text'
                                    className='form-control mx-1'
                                    value={item.province_count_double}
                                  />
                                  <input
                                    disabled
                                    type='text'
                                    className='form-control mx-1'
                                    value={item.province_count_person_double}
                                  />
                                </div>
                                <i
                                  onClick={() =>
                                    removeProvinceIdDouble(item.province_id)
                                  }
                                  className='fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer'
                                ></i>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className='col-12'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>آدرس محل برگزاری</label>
                    <textarea
                      className='form-control'
                      name='address'
                      value={values.address}
                      onChange={handleChange}
                    ></textarea>
                    <ErrorMessage error={errors.address} />
                  </div>
                </div>
              </div>

              <div className='col-12'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>توضیحات</label>
                    <TextEditor setFieldValue={setFieldValue} />
                    {/* <SunTextEditor handelChange={setFieldValue} /> */}
                    <ErrorMessage error={errors.description} />
                  </div>
                </div>
              </div>

              <div className='col-12'>
                <div className='d-flex flex-row justify-content-end my-3'>
                  <button className='btn btn-info btn-sm f-14'>
                    {submitFormLoading ? (
                      <div
                        className='spinner-border spinner-border-sm text-white mb-1'
                        role='status'
                      ></div>
                    ) : (
                      'ثبت مسابقه'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default CreateMatch;
